"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventInventoryRequestStatus;
(function (EventInventoryRequestStatus) {
    EventInventoryRequestStatus[EventInventoryRequestStatus["Requested"] = 1] = "Requested";
    EventInventoryRequestStatus[EventInventoryRequestStatus["Fulfilled"] = 2] = "Fulfilled";
})(EventInventoryRequestStatus || (EventInventoryRequestStatus = {}));
exports.default = EventInventoryRequestStatus;
